if (!customElements.get("mobile-menu-product-scroller")) {
  customElements.define(
    "mobile-menu-product-scroller",
    class MobileMenuProductScroller extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector("[data-product-scroll-row]");
        this.previousButton = this.querySelector("[data-product-scroll-prev]");
        this.nextButton = this.querySelector("[data-product-scroll-next]");

        if (!this.row || !this.previousButton || !this.nextButton) return;

        this.handlePrevious = () => this.scroll(-1);
        this.handleNext = () => this.scroll(1);
        this.updateButtons = () => {
          const maximumScroll = this.row.scrollWidth - this.row.clientWidth;
          this.previousButton.disabled = this.row.scrollLeft <= 1;
          this.nextButton.disabled = this.row.scrollLeft >= maximumScroll - 1;
        };

        this.previousButton.addEventListener("click", this.handlePrevious);
        this.nextButton.addEventListener("click", this.handleNext);
        this.row.addEventListener("scroll", this.updateButtons, {
          passive: true,
        });
        document.addEventListener("theme:modal:open", this.updateButtons);
        document.addEventListener("theme:drawer:open", this.updateButtons);

        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.row);
        this.itemsObserver = new MutationObserver(this.updateButtons);
        this.itemsObserver.observe(this.row, {
          childList: true,
          subtree: true,
        });
        requestAnimationFrame(this.updateButtons);
      }

      disconnectedCallback() {
        if (!this.row) return;

        this.previousButton.removeEventListener("click", this.handlePrevious);
        this.nextButton.removeEventListener("click", this.handleNext);
        this.row.removeEventListener("scroll", this.updateButtons);
        document.removeEventListener("theme:modal:open", this.updateButtons);
        document.removeEventListener("theme:drawer:open", this.updateButtons);
        this.resizeObserver?.disconnect();
        this.itemsObserver?.disconnect();
      }

      scroll(direction) {
        const product = this.row.querySelector(".mobile-menu-ux__product");
        if (!product) return;

        const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
        const prefersReducedMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

        this.row.scrollBy({
          left: direction * (product.getBoundingClientRect().width + gap),
          behavior: prefersReducedMotion ? "auto" : "smooth",
        });
      }
    }
  );
}

if (!customElements.get("bioray-mobile-menu")) {
  customElements.define(
    "bioray-mobile-menu",
    class extends HTMLElement {
      connectedCallback() {
        this.handleEditorSelect = event => {
          const section = this.closest(".shopify-section");
          if (!this.contains(event.target) && event.target !== section) return;

          const drawer = this.querySelector("header-drawer");
          drawer?.dispatchEvent(
            new CustomEvent("theme:drawer:open", { bubbles: true })
          );
          if (event.type === "shopify:block:select") {
            requestAnimationFrame(() =>
              event.target.scrollIntoView({ block: "nearest" })
            );
          }
        };
        document.addEventListener(
          "shopify:block:select",
          this.handleEditorSelect
        );
        document.addEventListener(
          "shopify:section:select",
          this.handleEditorSelect
        );
      }

      disconnectedCallback() {
        document.removeEventListener(
          "shopify:block:select",
          this.handleEditorSelect
        );
        document.removeEventListener(
          "shopify:section:select",
          this.handleEditorSelect
        );
      }
    }
  );
}
